'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadContents = loadContents;
exports.loadLessons = loadLessons;
exports.loadLessonsByCourse = loadLessonsByCourse;
exports.loadMyLessons = loadMyLessons;
exports.loadLessonsByName = loadLessonsByName;
exports.createLesson = createLesson;
exports.loadDirections = loadDirections;
exports.loadDirectionById = loadDirectionById;
exports.loadLessonById = loadLessonById;
exports.updateLesson = updateLesson;
exports.updateContentOrder = updateContentOrder;
exports.loadLessonsWithFirstContent = loadLessonsWithFirstContent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'LESSON/LESSON/LOAD';
var SUCCESS = 'LESSON/LESSON/SUCCESS';
var FAIL = 'LESSON/LESSON/FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SUCCESS:
      console.log('yup!!');
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        data: action.result
      });
    case FAIL:
      console.log(action.error);
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case "LESSONS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        lessons: action.result
      });
    case "LOAD_MY_LESSONS_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        lessons: action.result
      });
    case "LESSONS_FIRST_CONTENT_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        lessons_first_content: action.result
      });

    case "DIRECTION_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        direction: action.result
      });
    case "CONTENTS_BY_LESSON_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        contents_by_lesson: action.result
      });
    case "LESSONS_BY_NAME_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        lessons_by_name: action.result
      });
    case "LESSON_BY_ID_SUCCESS":
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        // accessToken: action.result.accessToken.id,
        lesson_by_id: action.result
      });
    default:
      return state;
  }
}

/*
* Actions
* * * * */
function isLoaded(globalState) {
  return globalState.lesson && globalState.lesson.loaded;
}

function loadContents(lessonId) {
  // includes the word (in `word_to_content` table) 
  // return dispatch =>
  //   dispatch({
  //     types: [LOAD],
  //     promise: ({oneClient}) => oneClient.get('/directions')
  //   })
  var mFilter = {
    where: {
      lessonId: lessonId,
      publish: 1
      // ,fields: {
      //   id:true,
      //   name:true,
      //   parentContentId:true,
      //   previousContentId :true
      // }
    }, order: "position asc"
  };
  console.log('loadContents by lesson');
  return {
    types: ["CONTENTS_BY_LESSON_LOAD", "CONTENTS_BY_LESSON_SUCCESS", "CONTENTS_BY_LESSON_FAIL"],
    promise: function promise(_ref) {
      var oneApiClient = _ref.oneApiClient;
      return oneApiClient.get('/contents' /** url: /contents/withWordToContent */
      , {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadLessons() {
  var mFilter = {
    // where: {
    //   lessonsId: lessonId
    //   ,publish: 1
    // }
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    // ,order: "lastUpdated desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["LESSONS_LOAD", "LESSONS_SUCCESS", "LESSONS_FAIL"],
    promise: function promise(_ref2) {
      var oneApiClient = _ref2.oneApiClient;
      return oneApiClient.get('/lessons', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadLessonsByCourse(directionId) {
  var mFilter = {
    where: {
      directionsId: directionId,
      publish: 1
      // ,fields: {
      //   id:true,
      //   name:true,
      //   parentContentId:true,
      //   previousContentId :true
      // }
      // ,order: "lastUpdated desc"
    } };
  // console.log('loadContents by lesson');
  return {
    types: ["LESSONS_LOAD", "LESSONS_SUCCESS", "LESSONS_FAIL"],
    promise: function promise(_ref3) {
      var oneApiClient = _ref3.oneApiClient;
      return oneApiClient.get('/lessons', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadMyLessons() {
  var mFilter = {
    // where: {
    //   lessonsId: lessonId
    //   ,publish: 1
    // }
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    // ,order: "lastUpdated desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["LOAD_MY_LESSONS_LOAD", "LOAD_MY_LESSONS_SUCCESS", "LOAD_MY_LESSONS_FAIL"],
    promise: function promise(_ref4) {
      var oneApiClient = _ref4.oneApiClient;
      return oneApiClient.get('/lessons', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadLessonsByName(name) {
  var mFilter = {
    limit: 10,
    where: {
      name: {
        like: '%' + name + '%'
      }
      // ,fields: {
      //   id:true,
      //   name:true,
      //   parentContentId:true,
      //   previousContentId :true
      // }
      // ,order: "lastUpdated desc"
    } };
  // console.log('loadContents by lesson');
  return {
    types: ["LESSONS_BY_NAME_LOAD", "LESSONS_BY_NAME_SUCCESS", "LESSONS_BY_NAME_FAIL"],
    promise: function promise(_ref5) {
      var oneApiClient = _ref5.oneApiClient;
      return oneApiClient.get('/lessons', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function createLesson(newLesson) {
  var data = {
    id: 0,
    name: newLesson.title,
    active: 1,
    directionsId: newLesson.directionsId,
    showCatalog: 1
  };
  // console.log('loadContents by lesson');
  return {
    types: ["CREATE_LESSON_LOAD", "CREATE_LESSON_SUCCESS", "CREATE_LESSON_FAIL"],
    promise: function promise(_ref6) {
      var oneApiClient = _ref6.oneApiClient;
      return oneApiClient.post('/lessons', {
        data: data
      });
    } //
  };
}

function loadDirections(name) {
  var mFilter = {
    limit: 10,
    where: {
      name: {
        like: '%' + name + '%'
      }
    }

  };
  // console.log('loadContents by lesson');
  return {
    types: ["DIRECTIONS_LOAD", "DIRECTIONS_SUCCESS", "DIRECTIONS_FAIL"],
    promise: function promise(_ref7) {
      var oneApiClient = _ref7.oneApiClient;
      return oneApiClient.get('/directions', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadDirectionById(id) {
  var mFilter = {
    where: {
      id: id
    }

  };
  // console.log('loadContents by lesson');
  return {
    types: ["DIRECTION_LOAD", "DIRECTION_SUCCESS", "DIRECTION_FAIL"],
    promise: function promise(_ref8) {
      var oneApiClient = _ref8.oneApiClient;
      return oneApiClient.get('/directions', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadLessonById(id) {
  var mFilter = {
    include: ['direction']

  };
  // return dispatch =>
  //   dispatch({
  //     types: [LOAD],
  //     promise: ({oneClient}) => oneClient.get('/directions')
  //   })
  // console.log('Load lesson by ID');
  return {
    types: ["LESSON_BY_ID_LOAD", "LESSON_BY_ID_SUCCESS", "LESSON_BY_ID_FAIL"],
    promise: function promise(_ref9) {
      var oneApiClient = _ref9.oneApiClient;
      return oneApiClient.get('/lessons/' + id, {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function updateLesson(data) {
  return {
    types: ["UPDATE_CONTENT_LOAD", "UPDATE_CONTENT_SUCCESS", "UPDATE_CONTENT_FAIL"],
    promise: function promise(_ref10) {
      var oneApiClient = _ref10.oneApiClient;
      return oneApiClient.put('/lessons', {
        data: data
      });
    } //
  };
}

function updateContentOrder(data) {
  // const data = {
  //   id: 0,
  //   name: name,
  //   active: 1,
  //   showCatalog: 1
  // };
  // console.log('loadContents by lesson');
  return {
    types: ["UPDATE_CONTENT_ORDER_LOAD", "UPDATE_CONTENT_ORDER_SUCCESS", "UPDATE_CONTENT_ORDER_FAIL"],
    promise: function promise(_ref11) {
      var oneApiClient = _ref11.oneApiClient;
      return oneApiClient.post('/contents/updatePosition', {
        data: data
      });
    } //
  };
}

function loadLessonsWithFirstContent() {
  var mFilter = {
    // where: {
    //   lessonsId: lessonId
    //   ,publish: 1
    // }
    // ,fields: {
    //   id:true,
    //   name:true,
    //   parentContentId:true,
    //   previousContentId :true
    // }
    // ,order: "lastUpdated desc"
  };
  // console.log('loadContents by lesson');
  return {
    types: ["LESSONS_FIRST_CONTENT_LOAD", "LESSONS_FIRST_CONTENT_SUCCESS", "LESSONS_FIRST_CONTENT_FAIL"],
    promise: function promise(_ref12) {
      var oneApiClient = _ref12.oneApiClient;
      return oneApiClient.get('/lessons/withContent', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/lesson.js
// module id = 90
// module chunks = 0